<div *ngIf="inputStorageObject && inputStorageService?.isImagePreviewEnabled">
    <mat-toolbar *ngIf="_canHandleMetadata">
        <button
            mat-icon-button
            [tcTooltip]="_translationPrefix + '.saveMetadata' | translate: _locale.language"
            (click)="_updateMetadata()"
        >
            <mat-icon>save</mat-icon>
        </button>
    </mat-toolbar>

    <mat-expansion-panel expanded disabled>
        <div class="image-preview">
            <div class="preview-container">
                <div [style.background-image]="'url(' + inputStorageObject.previewUrl + ')'"></div>
            </div>

            <div *ngIf="_canHandleMetadata">
                <mat-form-field class="w-100">
                    <mat-label>{{ _translationPrefix + '.imageSize' | translate: _locale.language }}</mat-label>
                    <input
                        matInput
                        readonly
                        [ngModel]="_metadata.width ? _metadata.width + ' x ' + _metadata.height + ' px' : '-'"
                    />
                </mat-form-field>

                <mat-form-field class="w-100">
                    <mat-label>{{ _translationPrefix + '.altText' | translate: _locale.language }}</mat-label>
                    <input matInput [(ngModel)]="_metadata.alttext" />
                </mat-form-field>
            </div>
        </div>

        <div class="loader" *ngIf="_isLoading">
            <div class="icon-loading"></div>
        </div>
    </mat-expansion-panel>
</div>
